<div class="models-row">
  <div class="model-select-wrapper">
    <label>{{ labelKey | translate }}</label>
    <ng-select
      [items]="models"
      bindLabel="name"
      bindValue="id"
      [ngModel]="selectedModel"
      (ngModelChange)="selectedModelChange.emit($event)"
      [placeholder]="placeholderKey | translate"
      [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
      [clearable]="true"
      [searchable]="true">
      <ng-template ng-label-tmp let-item="item">
        <span class="model-option-label">
          <span class="model-option-name">{{ item.name }}</span>
          @if (item.is_deployed) {
            <fa-icon [icon]="icons.faCheck" class="model-deployed-icon" [title]="'MODELS.DEPLOYED' | translate"></fa-icon>
          }
          @if (item.tag) {
            <span class="model-tag" [style.background-color]="item.tag.bg_color" [style.color]="item.tag.text_color"
              [title]="item.tag.name">{{ item.tag.name }}</span>
          }
        </span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <div class="model-option">
          <span class="model-option-label">
            <span class="model-option-name">{{ item.name }}</span>
            @if (item.is_deployed) {
              <fa-icon [icon]="icons.faCheck" class="model-deployed-icon" [title]="'MODELS.DEPLOYED' | translate"></fa-icon>
            }
            @if (item.tag) {
              <span class="model-tag" [style.background-color]="item.tag.bg_color" [style.color]="item.tag.text_color"
                [title]="item.tag.name">{{ item.tag.name }}</span>
            }
          </span>
          @if (showDelete) {
            <button type="button" class="model-option-delete" [title]="'BUTTON.DELETE' | translate"
              (click)="onDelete(item, $event)" (mousedown)="$event.stopPropagation()">
              <fa-icon [icon]="icons.faTrash"></fa-icon>
            </button>
          }
        </div>
      </ng-template>
    </ng-select>
  </div>

  <div class="model-actions">
    <button type="button" class="secondary-btn" [disabled]="importDisabled" (click)="importModel.emit()">
      <fa-icon [icon]="icons.faUpload"></fa-icon>
      <span>{{ 'BUTTON.IMPORT' | translate }}</span>
    </button>
    <button type="button" class="secondary-btn" [disabled]="exportDisabled" (click)="exportModel.emit()">
      <fa-icon [icon]="icons.faDownload"></fa-icon>
      <span>{{ 'BUTTON.EXPORT' | translate }}</span>
    </button>
  </div>
</div>
